/**
 * @property open {boolean} if open dialog
 * @property ifInviteButtonDisable {boolean} if disable the invite button
 * @property handleCloseDialog {function} callback of close dialog
 * @property handleSendInvite {function} callback of send invite
 */
import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import AcInputField from '../framework/InputField/InputField';
import Clear from 'material-ui/svg-icons/content/clear';
import FlatButton from 'material-ui/FlatButton';
import MenuItem from 'material-ui/MenuItem';
import { buttonBlueColor } from "../../utils/utility";
import SuccessTip from '../Employees/UpdateAdminUserTip';
import Select from 'react-select';

// css
import './industry-dialog.css';
// import 'react-select-plus/dist/react-select-plus.css';

// icon
import { Checkbox } from 'material-ui';

class IndustryDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clientNameValue: '',
      roleValue: '',
      fieldErrorTip: '', // for field input error tips
      ifButtonDisable: true,
      isPrimaryContract: false,
      UpdateAdminUserTipDialogOpen: false,
      disableSelect: false,
      requestParams: {
        firstName: '',
        lastName: '',
        email: '',
        clientId: '',
        roleId: '',
        primaryContact: false
      }
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.client_options.length > 0) {
      if (/^(administrator|team member)/gi.test(nextProps.roleName)) {
        this.setState({
          roleValue: nextProps.client_options[2].value,
          disableSelect: true, // disable Select Component.
          requestParams: {
            ...this.state.requestParams,
            roleId: nextProps.client_options[2].value
          }
        })
      } else if (/^(system administrator|account manager)/gi.test(nextProps.roleName)) {
        this.setState({
          roleValue: nextProps.client_options[0].value,
          disableSelect: true, // disable Select Component.
          requestParams: {
            ...this.state.requestParams,
            roleId: nextProps.client_options[0].value
          }
        })
      } else {
        this.setState({
          roleValue: nextProps.client_options[0].value,
          requestParams: {
            ...this.state.requestParams,
            roleId: nextProps.client_options[0].value
          }
        })
      }
    }

    if (nextProps.ifSendInvitationSuccess) {
      this.setState({
        UpdateAdminUserTipDialogOpen: true,
        ifButtonDisable: true,
        fieldErrorTip: '',
        requestParams: {
          firstName: '',
          lastName: '',
          email: '',
          clientId: '',
          roleId: '',
          primaryContact: false
        }
      })
    }
  }
  menuItems(items) {
    return items.map((item) => (
      <MenuItem
        key={item.value}
        value={item.value}
        primaryText={item.label}
      />
    ));
  }
  handleRoleChange(value) {
    this.setState({
      roleValue: value.value,
      requestParams: {
        ...this.state.requestParams,
        roleId: value.value
      }
    })
  }
  handleCloseDialog() {
    this.props.rollbackStatus();
    this.setState({
      clientNameValue: '',
      roleValue: '',
      fieldErrorTip: '', // for field input error tips
      ifButtonDisable: true,
      UpdateAdminUserTipDialogOpen: false,
      disableSelect: false,
      isPrimaryContract: false,
      requestParams: {
        firstName: '',
        lastName: '',
        email: '',
        clientId: '',
        roleId: '',
        primaryContact: false
      }
    }, () => {
      this.props.handleCloseDialog();
    })
  }

  handleFirstName(e, value) {
    if (value.trim().length > 0) {
      if (!/^[a-zA-Z]+$/g.test(value)) {
        this.setState({
          fieldErrorTip: 'Invalid firstName',
          ifButtonDisable: true
        });
      } else {
        this.setState({
          requestParams: {
            ...this.state.requestParams,
            firstName: value,
          },
          fieldErrorTip: ''
        }, () => {
          this.handleDisableButton()
        })
      }
    } else {
      this.setState({
        fieldErrorTip: ''
      })
    }
  }
  handleLastName(e, value) {
    if (value.trim().length > 0) {
      if (!/^[A-z]+(-{0,1}[A-z])+$/g.test(value)) {
        this.setState({
          fieldErrorTip: 'Invalid lastName',
          ifButtonDisable: true
        });
      } else {
        this.setState({
          requestParams: {
            ...this.state.requestParams,
            lastName: value,
          },
          fieldErrorTip: ''
        }, () => {
          this.handleDisableButton()
        })
      }
    } else {
      this.setState({
        fieldErrorTip: ''
      })
    }
  }
  handleTitle(e, value) {
    if (value.trim().length > 0) {
      if (/^[a-zA-Z][a-zA-Z0-9\s]*$/g.test(value.trim())) {
        this.setState({
          fieldErrorTip: '',
          requestParams: {
            ...this.state.requestParams,
            title: value
          }
        }, () => {
          this.handleDisableButton();
        })
      } else {
        this.setState({
          fieldErrorTip: 'Title must be 5 to 20 characters.',
          ifButtonDisable: true
        });
      }
    } else {
      this.setState({
        fieldErrorTip: ''
      })
    }
  }
  handleEmail(e, value) {
    let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (value.trim().length > 0) {
      if (!re.test(value)) {
        this.setState({
          fieldErrorTip: 'Invalid email',
          ifButtonDisable: true
        });
      } else {
        this.setState({
          fieldErrorTip: '',
          requestParams: {
            ...this.state.requestParams,
            email: value
          }
        }, () => {
          this.handleDisableButton();
        });
      }
    } else {
      this.setState({
        fieldErrorTip: ''
      })
    }
  }
  handleDisableButton() {
    const { firstName, lastName, clientId, email } = this.state.requestParams;

    let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (
      /^[a-zA-Z]+$/g.test(firstName) &&
      /^[A-z]+(-{0,1}[A-z])+$/g.test(lastName) &&
      re.test(email) &&
      clientId !== ''
    ) {
      this.setState({
        ifButtonDisable: false,
        fieldErrorTip: ''
      })
    }
  }
  handleSendInvite() {
    if (/^(administrator|team member)/gi.test(this.props.roleName)) {
      this.props.inviteBusinessMember(this.state.requestParams);
    } else if (/^(system administrator|account manager)/gi.test(this.props.roleName)) {
      this.props.send_invitation(this.state.requestParams);
    }
  }
  handleCloseSuccessTip() {
    this.setState({
      clientNameValue: '',
      roleValue: '',
      fieldErrorTip: '', // for field input error tips
      ifButtonDisable: true,
      UpdateAdminUserTipDialogOpen: false,
      disableSelect: false,
      isPrimaryContract: false,
      requestParams: {
        firstName: '',
        lastName: '',
        email: '',
        clientId: '',
        roleId: ''
      }
    });
    this.props.rollbackStatus();
  }
  handleInviteAnotherClient() {
    this.props.handleInviteAnotherClient();
    this.props.rollbackStatus(false);
  }
  handleClientNameChange(value) {
    this.setState({
      clientNameValue: value.value,
      requestParams: {
        ...this.state.requestParams,
        clientId: value.value
      }
    }, () => {
      this.handleDisableButton();
    });
  }

  handlePrimaryContractChange(e, isChecked){
    this.setState({
      isPrimaryContract: isChecked,
      requestParams: {
        ...this.state.requestParams,
        primaryContact: isChecked
      }
    })
  }

  render() {
    const isBusinessInvite = /^(administrator|team member)/gi.test(this.props.roleName)
    return (
      <div className="industry-dialog">
        <SuccessTip
          UpdateAdminUserTipDialogOpen={this.state.UpdateAdminUserTipDialogOpen}
          closeUpdateAdminUserTipDialog={() => this.handleCloseSuccessTip()}
          continue={() => this.handleInviteAnotherClient()}
          closeLabel="close"
          ifHiddenContinueButton={true}
          continueLabel="INVITE ANOTHER CLIENT"
        >
          <p style={{ color: 'black', textAlign: 'center', fontWeight: 'bolder' }}>Your invitation email has been sent.</p>
        </SuccessTip>
        <Dialog
          open={this.props.open}
          contentStyle={{ width: '520px' }}
          autoScrollBodyContent={true}
        >
          <div className="ac-clients-wrapper">
            <Clear
              onClick={() => this.handleCloseDialog()}
              style={{ position: 'absolute', top: '-1em', right: '-0.8em', cursor: 'pointer' }}
            />
            <h3>{isBusinessInvite ? 'INVITE BUSINESS UNIT TEAM MEMBER' : 'INVITE CLIENT'}</h3>
            <div className="select-field clearfix" style={{ marginBottom: '0.8em' }}>
              <p style={{ float: 'left', marginTop: '9px', fontWeight: 'bolder' }}>Role</p>
              <Select
                className="client-role-selector "
                value={this.state.roleValue}
                clearable={false}
                options={this.props.client_options}
                onChange={this.handleRoleChange.bind(this)}
                disabled={this.state.disableSelect}
              />
            </div>

            <AcInputField
              labelTitle="Title"
              labelStyle={{ float: 'left', fontSize: '13px', color: 'black', marginTop: '0.5em', fontWeight: 'bolder' }}
              inputContainerId="clientTitle"
              borderColor="black"
              onChange={(e, value) => this.handleTitle(e, value)}
            />
            <AcInputField
              labelTitle="First Name"
              ifRequireField={true}
              labelStyle={{ float: 'left', fontSize: '13px', color: 'black', marginTop: '0.5em', fontWeight: 'bolder' }}
              inputContainerId="clientFirstName"
              borderColor="black"
              onChange={(e, value) => this.handleFirstName(e, value)}
            />
            <AcInputField
              labelTitle="Last Name"
              ifRequireField={true}
              labelStyle={{ float: 'left', fontSize: '13px', color: 'black', marginTop: '0.5em', fontWeight: 'bolder' }}
              inputContainerId="clientLastName"
              borderColor="black"
              onChange={(e, value) => this.handleLastName(e, value)}
            />
            <AcInputField
              labelTitle="E-mail"
              ifRequireField={true}
              labelStyle={{ float: 'left', fontSize: '13px', color: 'black', marginTop: '0.5em', fontWeight: 'bolder' }}
              inputContainerId="clientEmail"
              borderColor="black"
              onChange={(e, value) => this.handleEmail(e, value)}
            />
            {
              isBusinessInvite && (
                <div className="select-field clearfix" style={{marginBottom:'10px', height:'40px'}}>
                  <p style={{ marginTop: '5px', fontWeight: 'bolder', position:'absolute' }}>
                    <span>Primay Business <br />Unit Contact</span>
                    <span style={{marginLeft:'68px', position:'absolute', top:'5px'}}>
                      <Checkbox iconStyle={{fill:'#000', fillOpacity:'0.7'}} 
                        checked={this.state.isPrimaryContract} 
                        onCheck={this.handlePrimaryContractChange.bind(this)} />
                    </span>
                  </p>     
                </div>
              )
            }
            <div className="select-field clearfix" style={{height: '41px'}}>
              <p style={{ float: 'left', marginTop: '9px', fontWeight: 'bolder' }}>
                {isBusinessInvite ? (<span>Business Unit<br /> Name</span>) : 'Client Name'}<em style={{ color: 'red' }}>*</em>
              </p>
              <Select
                className="client-name-selector "
                value={this.state.clientNameValue}
                clearable={false}
                options={
                  this.props.roleName !== undefined && isBusinessInvite ? this.props.businessUnitOptions : this.props.client_names}
                onChange={this.handleClientNameChange.bind(this)}
              />
            </div>
          </div>
          <div className="ac-clients-form-btns clearfix" style={{ marginTop: '2em' }}>
            <FlatButton
              label="SEND INVITE"
              labelStyle={{padding: 0, fontSize: '13px'}}
              style={{ width: '100px', height: '30px', lineHeight: 'auto', fontSize: '13px', color: 'white ', float: 'right' }}
              backgroundColor={buttonBlueColor()}
              hoverColor={buttonBlueColor()}
              onClick={() => this.handleSendInvite()}
              disabled={this.state.ifButtonDisable}
            />
            <FlatButton
              label="Cancel"
              labelStyle={{padding: 0, fontSize: '13px'}}
              style={{ float: 'right', width: '73px', height: '30px', lineHeight: 'auto', color: 'black', fontSize: '13px', marginLeft: '-1.6em', border: '1px solid black', marginRight: '1em' }}
              onClick={() => this.handleCloseDialog()}
              hoverColor="none"
            />

            <p className="ac-clients-error">{this.props.send_invitation_error_msg || this.state.fieldErrorTip}</p>
          </div>
        </Dialog>
      </div>

    )
  }
}

export default IndustryDialog;


// WEBPACK FOOTER //
// ./src/components/Clients/IndustryDialog.jsx